import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

// Страницы
import { AuthPage } from '../pages/AuthPage';
import { DealsListPage } from '../pages/DealsListPage';
import { DealDetailPage } from '../pages/DealDetailPage';
import { CreateDealPage } from '../pages/CreateDealPage';
import { CompanyInfoPage } from '../pages/CompanyInfoPage';
import { CallbackPage } from '../pages/CallbackPage';

/**
 * Защищённый маршрут — редиректит на /auth если не авторизован
 */
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '16px',
        color: 'var(--tgui--hint_color)',
      }}>
        Загрузка...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}

/**
 * Маршрутизация приложения
 */
export function AppRouter() {
  return (
    <Routes>
      {/* Авторизация */}
      <Route path="/auth" element={<AuthPage />} />

      {/* Защищённые маршруты */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <DealsListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/deal/:dealId"
        element={
          <ProtectedRoute>
            <DealDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/create"
        element={
          <ProtectedRoute>
            <CreateDealPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/company"
        element={
          <ProtectedRoute>
            <CompanyInfoPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/callback"
        element={
          <ProtectedRoute>
            <CallbackPage />
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
